
/* var today = new Date();
var dd = String(today.getDate()).padStart(2, '0');
var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
var yyyy = today.getFullYear();
today = dd + '/' + mm + '/' + yyyy; */

var md5 = require('js-md5');
let code = 'as-!wdfkjh@$%+asd';

//console.log(md5(today));



export const RestUrls = {
    Code: '?code=' + md5(code),
    Code2: md5(code),
    /* Code2: md5(code) + '1', */
    SiteData: `https://www.avisror.com/appi/welcome/SiteDataItems?code=` + md5(code),
    Pages: 'https://www.avisror.com/appi/',
    Leads: 'https://www.avisror.com/appi/welcome/leadform',
    Users: `https://jsonplaceholder.typicode.com/`,
}   

export const ConstantsNames = {
    base_url : 'https://www.avisror.com',
    projectsPageName : '/פרויקטים/',
    centerPageName : '/אביסרור_סנטר/',
    jobsFormIframe : 'https://www.avisror.com/appi/welcome/sendJobMail?jobId=',
    maskyooIframe : 'https://www.avisror.com/appi/welcome/showMaskyoo?projectId=',
    pic : 'https://www.avisror.com/appi/assets/img/pictures/',
    files : 'https://www.avisror.com/appi/assets/files/',
    pic2 : 'https://www.avisror.com/appi/assets/img/',
    //version : Math.floor(Math.random() * 100000)
    version : 1
}